<section *ngIf="appointments.length" class="orbi-appointment-card" [attr.aria-label]="title">
  <div class="orbi-appointment-card__head">
    <span class="material-icons-round orbi-appointment-card__icon" aria-hidden="true">calendar_month</span>
    <h3 class="orbi-appointment-card__title">{{ title }}</h3>
  </div>

  <div
    *ngFor="let appointment of visibleAppointments; trackBy: trackByConfirmation"
    class="orbi-appointment-card__appointment"
    [class.orbi-appointment-card__appointment--single]="isSingle"
  >
    <p *ngIf="!isSingle && stateLabel(appointment)" class="orbi-appointment-card__state">
      {{ stateLabel(appointment) }}
    </p>

    <!-- Date/time (AC 3.1) -->
    <p *ngIf="dateTimeLine(appointment)" class="orbi-appointment-card__datetime">{{ dateTimeLine(appointment) }}</p>

    <!-- Reason for visit (AC 3.2) -->
    <p *ngIf="appointment.reasonForVisit" class="orbi-appointment-card__reason">{{ appointment.reasonForVisit }}</p>

    <a
      *ngIf="hasMapPreview(appointment)"
      class="orbi-appointment-card__map"
      [href]="mapUrl(appointment)"
      target="_blank"
      rel="noopener noreferrer"
      [attr.aria-label]="'View ' + (appointment.locationAddress || 'the appointment location') + ' on a map'"
    >
      <img
        class="orbi-appointment-card__map-image"
        [src]="mapPreviewUrl(appointment)"
        [width]="mapPreview.width"
        [height]="mapPreview.height"
        loading="lazy"
        alt=""
      />
    </a>

    <div *ngIf="appointment.locationAddress" class="orbi-appointment-card__location">
      <ng-container *ngIf="!hasMapPreview(appointment) && hasMappableDestination(appointment); else addressText">
        <a
          class="orbi-appointment-card__address-link"
          [href]="mapUrl(appointment)"
          target="_blank"
          rel="noopener noreferrer"
          [attr.aria-label]="'Get directions to ' + appointment.locationAddress"
          >{{ appointment.locationAddress }}</a
        >
      </ng-container>
      <ng-template #addressText>
        <span class="orbi-appointment-card__address">{{ appointment.locationAddress }}</span>
      </ng-template>
    </div>

    <div *ngIf="actionsFor(appointment).length" class="orbi-appointment-card__actions">
      <ui-button
        *ngFor="let action of actionsFor(appointment); let i = index"
        class="orbi-appointment-card__btn"
        [buttonText]="labelFor(action, appointment)"
        [rank]="actionVariant(i)"
        size="small"
        [buttonDisabled]="isSpent(action, appointment)"
        [iconRight]="trailingIconFor(action, appointment)"
        (handleClick)="onAction(action, appointment)"
      ></ui-button>
    </div>
  </div>

  <div *ngIf="hasSeeAll" class="orbi-appointment-card__see-all">
    <ui-button
      [buttonText]="seeAllLabel"
      rank="primary"
      size="small"
      addClass="orbi-appointment-card__see-all-btn"
      (handleClick)="onSeeAll()"
    ></ui-button>
  </div>
</section>
